<mat-toolbar>
  <div class="left">
    @if (backButtonLink !== null) {
      <div class="back-button-container">
        <button mat-icon-button (click)="goBack()">
          <mat-icon>chevron_left</mat-icon>
        </button>
      </div>
    } @else {
      <div class="spacer"></div>
    }
    <div class="rows">
      @if (currentUser$ | async; as user) {
        <div class="title" (click)="user.role === 'SUPER' && handleTitleClick()">
          {{ title }}
        </div>
      }
      <ng-content select=".details"></ng-content>
    </div>
  </div>
  <div class="actions">
    <ng-content select=".actions"></ng-content>
  </div>
</mat-toolbar>
